import React from 'react';
import { object, string, bool } from 'prop-types';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

const UserImageLink = ({ context, user, className, size48 }) => {
  if (!user) {
    return null;
  }

  const linkClass = size48 ? styles.link48 : styles.link;
  const classes = ['clickable', linkClass, StringConstantsMixin.constants.XLATE.NONE];
  if (className) {
    classes.push(className);
  }
  return (
    <a
      className={classes.join(' ')}
      href={LanguageSupportUtil.wrapUrlSafe(ServerCommunicationUtil.usersPath(user), context ? context.languageRegionCode : 'en-US')}
      target="_blank"
      title={`${user.first_name || user.firstName} ${user.last_name || user.lastName}`}
      onClick={e => e.stopPropagation()}
    >
      <img
        alt={StringConstantsMixin.strings.USER_AVATAR_ALT}
        className={`lazyload ${styles.image}`}
        data-src={
          user.profile_photo_url
            ? user.profile_photo_url
            : `/api/alltrails/profile_photos/${user.id}/image?size=icon&key=${ServerCommunicationUtil.apiKey}`
        }
      />
    </a>
  );
};

UserImageLink.propTypes = {
  context: object.isRequired,
  user: object.isRequired,
  className: string,
  size48: bool
};

UserImageLink.defaultProps = {
  size48: false,
  className: ''
};

export default UserImageLink;
